import { render, staticRenderFns } from "./SelectorsPanelHistoryViewMode.vue?vue&type=template&id=8c6f0cf8&"
import script from "./SelectorsPanelHistoryViewMode.vue?vue&type=script&lang=ts&"
export * from "./SelectorsPanelHistoryViewMode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports